import {texture} from "p3";
import NPC from "./NPC";
import definitions from "../../../definitions";
import GameScene from "../../../scenes/GameScene";

export default class NPCBuffSow extends NPC {
    constructor() {
        super(definitions.NPC_ID.BUFF_SOW);

        this._moved = false;
        this.collisionRadius = 150;
        this.collisionOffsetX = 5;
        this.collisionOffsetY = -150;
    }

    init() {
        super.init();

        this.addViewWithTexture(texture("char_buff_sow_idle_00"));

        this.addShadow(definitions.SHADOW_SIZE.LARGE, 1, new PIXI.Point(0, 0));
        this.animateIdle(1);
        
        if(GameScene.active.questManager.isQuestComplete('quest_1', 'buff_sow')) {
            this.moveToDefeatedPosition();
        }
    }

    moveToDefeatedPosition() {
        if (this._moved) {
            return;
        }

        this._moved = true;
        this.x -= 385;
        this.y += 200;
        this.scale.x = -1;
    }
}